import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Characters from "@/pages/Characters";
import CharacterDetail from "@/pages/CharacterDetail";
import Campaigns from "@/pages/Campaigns";
import CampaignArchive from "@/pages/CampaignArchive";
import CampaignDetail from "@/pages/CampaignDetail";
import Store from "@/pages/Store";
import Friends from "@/pages/Friends";
import AdminQuestions from "@/pages/AdminQuestions";
import AdminPanel from "@/pages/AdminPanel";
import Help from "@/pages/Help";
import NotFound from "@/pages/NotFound";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 mono amber">// Booting terminal...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Protected><Layout /></Protected>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="characters" element={<Characters />} />
              <Route path="characters/:id" element={<CharacterDetail />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="campaigns/archive" element={<CampaignArchive />} />
              <Route path="campaigns/:id" element={<CampaignDetail />} />
              <Route path="store" element={<Store />} />
              <Route path="shop" element={<Store />} />
              <Route path="friends" element={<Friends />} />
              <Route path="help" element={<Help />} />
              <Route path="admin" element={<AdminPanel />} />
              <Route path="admin/questions" element={<AdminQuestions />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
